// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__YMgM4","col":"CardReaderDesc_col__V1z5Z","label":"CardReaderDesc_label__2QiaY"};